function InitalizeHobbiesAndInterestsAssisted() {
    $('#hobbies-assisted-container .Expando').expando({ duration: '200' });

    $('#hobbies-assisted-container input:checkbox').click(function() {
        UpdateHobbiesSelections();
    });

    $('#hobbies-assisted-container').find('select').change(function () {
        UpdateHobbiesSelections();
    });

    UpdateHobbiesSelections();
}

function UpdateHobbiesSelections() {
    $('#HobbiesSelections').val('');
    var hobbiesSelections = '';

    $.each($('#hobbies-assisted-container input:checkbox:checked'), function(i, value) {
        var currentItem = $(value).closest('.SelectionBaseBoolCheckBox');
        var hobbyValue = currentItem.find('input:hidden:last').prev().val();
        var hobbyDescription = currentItem.find('input:hidden:last').val();

        var currentSelection = $(value).closest('.hobbies-assisted-child');

        var fromDegreeSelected = 1;
        var fromDegreeOption = currentSelection.find('#childItem_FromDegreeSelected');
        if (fromDegreeOption.length > 0) {
            fromDegreeSelected = fromDegreeOption.val();
            }

        var toDegreeSelected = 9;
        var toDegreeOption = currentSelection.find('#childItem_ToDegreeSelected');
        if(toDegreeOption.length > 0) {
            toDegreeSelected = toDegreeOption.val();
        }

        var hobbySelection = FormatHobbyValue(hobbyDescription, hobbyValue, fromDegreeSelected, toDegreeSelected);
        if (hobbySelection != null) {
            hobbiesSelections = hobbiesSelections + hobbySelection + '~';
        }
    });

    $('#HobbiesSelections').val(hobbiesSelections);
}

function FormatHobbyValue(hobbyDescription, hobbyValue, fromDegreeSelected, toDegreeSelected) {

    var hobbyValues = hobbyValue.split('|');

    if (hobbyValues.length <= 1) {
        return null;
    }

    var hobbySelectionValues = hobbyValues[1].split('-');
    if (hobbySelectionValues.length <= 1) {
        return hobbyValues[0]+ '|' +hobbyValues[1] + ':' + hobbyDescription;
    }

    var hobbyFirstValue = hobbySelectionValues[0].substring(0, hobbySelectionValues[0].length - 1);
    var hobbysecondValue = hobbySelectionValues[1].substring(0, hobbySelectionValues[1].length - 1);

    return hobbyValues[0] + '|' + hobbyFirstValue + fromDegreeSelected + '-' + hobbysecondValue + toDegreeSelected + ':' + hobbyDescription + ' -- ' + fromDegreeSelected + ' To ' + toDegreeSelected;
}
